import axios from "axios";
import { Dispatch } from "redux";
import Url from "../../ApiConfig";
import { GetObservationAboutPatientDetailBody, GetObservationAboutPatientDetail } from "./Model";
import {
  getObservationAboutPatientDetailAPIResClearAction,
  getObservationAboutPatientDetailErrorAction,
  getObservationAboutPatientDetailLoadingAction,
  getObservationAboutPatientDetailSuccessAction,
  getObservationAboutPatientDetailUpdateAPIMsgAction,
} from "./Actions";
import { GetObservationAboutPatientDetailActionTypes } from "./ActionTypes";
import { setupInterceptorsTo } from "../Authentication/Interceptors";

const userToken = localStorage.getItem("access");
const headers = {
  Accept: "application/json",
  "Content-type": "application/json",
  Authorization: `Bearer ${userToken}`,
};

let apiRes = {} as GetObservationAboutPatientDetail;
export const getObservationAboutPatientDetails = (payload: GetObservationAboutPatientDetailBody) => {
  return function (dispatch: Dispatch<GetObservationAboutPatientDetailActionTypes>) {
    dispatch(getObservationAboutPatientDetailLoadingAction(true));
    setupInterceptorsTo(axios)
      .post(
        Url.baseUrl + `/curatorapp/api/curator/getObservationAboutPatientDetail`,
        payload,
        { headers: headers },
      )
      .then((res) => {
        apiRes = res.data;
        dispatch(getObservationAboutPatientDetailLoadingAction(false));
        dispatch(getObservationAboutPatientDetailSuccessAction(
          res.data,
          res.data.message !== undefined ? res.data.message : "Patient modified successfully.",
          res.data.status,));
      })
      .catch((error) => {
        dispatch(getObservationAboutPatientDetailLoadingAction(false));
        dispatch(
          getObservationAboutPatientDetailErrorAction(
            {} as GetObservationAboutPatientDetail,
            error.response !== undefined
              ? error.response.data.message || error.response.data.detail
              : "Something went wrong",
            error.status !== undefined ? error.response.data.status || 0 : 0,
          ),
        );
      });
  };
};

export const getObservationAboutPatientDetailUpdateAPIResMsg = () => {
  return function (dispatch: Dispatch<GetObservationAboutPatientDetailActionTypes>) {
    dispatch(getObservationAboutPatientDetailUpdateAPIMsgAction(apiRes as GetObservationAboutPatientDetail, "", 0));
  };
};

export const clearGetObservationAboutPatientDetailClearAPIRes = () => {
  return function (dispatch: Dispatch<GetObservationAboutPatientDetailActionTypes>) {
    dispatch(getObservationAboutPatientDetailAPIResClearAction({} as GetObservationAboutPatientDetail, "", 0));
  };
};
